module.exports = __webpack_public_path__ + "img/recruit-gj.0dc9fc10.png";